/**
 * Normalizes fuzzy number text into clean numbers.
 * Handles various formats including currency symbols, text descriptions,
 * and different number representations.
 *
 * @param value The string value to normalize
 * @returns The normalized number (float), or null if invalid
 */
export function normalizeNumberValue(value) {
    if (!value || typeof value !== "string") {
        return null;
    }
    try {
        const trimmed = value.trim().toLowerCase();
        // Handle common patterns for financial amounts
        let cleaned = trimmed;
        // Remove dollar signs and common currency symbols
        cleaned = cleaned.replace(/[$,]/g, "");
        // Handle text descriptions for large numbers
        let multiplier = 1;
        if (cleaned.includes("billion") || cleaned.includes("b")) {
            multiplier = 1000000000;
            cleaned = cleaned.replace(/billion|b/g, "").trim();
        }
        else if (cleaned.includes("million")) {
            multiplier = 1000000;
            cleaned = cleaned.replace(/million/g, "").trim();
        }
        else if (cleaned.includes("thousand") || cleaned.includes("k")) {
            multiplier = 1000;
            cleaned = cleaned.replace(/thousand|k/g, "").trim();
        }
        // Remove any remaining non-numeric characters except decimal points and minus signs
        cleaned = cleaned.replace(/[^\d.-]/g, "");
        // Parse the number
        const number = parseFloat(cleaned);
        if (isNaN(number)) {
            return null;
        }
        // Calculate final value
        const finalValue = number * multiplier;
        return finalValue;
    }
    catch (error) {
        // If parsing fails, return null
        return null;
    }
}
//# sourceMappingURL=number.js.map